// extracted by mini-css-extract-plugin
export default {"CustomPackage":"CustomPackage_CustomPackage__X+Knf","customImage":"CustomPackage_customImage__cCUEM"};